import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import MaterialTable from 'material-table';
import Documentos from 'views/Shared/Documentos';

// reactstrap components
import { Card, CardBody, Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, Input, Container } from "reactstrap";
import { table_translate, table_style } from "constants/MaterialTable.js";
import ProgressBar from "components/ProgressBar/StepperProgress";


// services
import { showMessage } from "../../../services/message.js";
import { api_GET, api_POST } from "../../../services/api_service.js";

//Context
import { useAuth } from '../../../context/auth';

export default function DestinoRequerimentoAumentoCapacidade({ history }) {
    const { session, setLoading, setupSistema } = useAuth();
    const location = useLocation();
    const [requerimento, set_requerimento] = useState(null);
    const [locais, set_locais] = useState([]);
    const [capacidadeAtualizada, set_capacidadeAtualizada] = useState('');
    const opcao = {
        tipoCadastro: "Requerimento",
        segmento: "Destino Final",
        categoria: "RCC"
    }

    const [localDestinoAtual, set_LocalDestinoAtual] = useState({
        identificacao: "",
        cep: "",
        logradouro: "",
        numEndereco: "",
        complemento: "",
        bairro: "",
        cidade: "",
        uf: "",
        geoLocalizacao: "",
        capacidadeAntiga: "",
        capacidadeNova: ""
    });

    const [steps, set_steps] = React.useState([]);
    const loadSteps = () => {
        api_GET('setupSolicitacao/GetByAcaoId/' + location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id)
            .then(result => {
                if (result.data.solicitacaoAcoes.filter(f => f.setupSolicitacaoAcao_Id == location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id)[0].acaoDocumentos.length > 0) {
                    set_steps(["Locais de Destinação", "Documentação"]);
                }
                else {
                    set_steps(["Locais de Destinação"]);
                }
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const [step, set_step] = React.useState(0);
    const handleStepAnterior = (_requerimento) => {
        set_requerimento(_requerimento)
        set_step(step - 1);
    }

    const [modal, setModal] = useState(false);
    const toggle = (rowData) => {
        set_LocalDestinoAtual({
            identificacao: rowData.identificacao,
            cep: rowData.cep,
            bairro: rowData.bairro,
            cidade: rowData.cidade,
            complemento: rowData.complemento,
            geoLocalizacao: rowData.geoLocalizacao,
            logradouro: rowData.logradouro,
            numEndereco: rowData.numEndereco,
            uf: rowData.uf,
            capacidadeAntiga: rowData.capacidade
        });

        setModal(!modal);
    };

    const loadRequerimento = () => {
        if (location.state.protocolo != null && location.state.protocolo.protocoloDestino[0].protocoloDestinoLocais.length > 0) {
            set_locais(location.state.protocolo.protocoloDestino[0].protocoloDestinoLocais)
        }

        if (location.state.requerimento == null) {
            setLoading(true);
            let json_submit = {
                protocolo_Id: location.state.protocolo.protocolo_Id,
                requerimento_Id: 0,
                nomeSolicitante: location.state.protocolo.nomeSolicitante,
                email: location.state.protocolo.email,
                cpf_Cnpj: location.state.protocolo.cpf_Cnpj,
                setupSolicitacaoAcao_Id: location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id,
            }

            api_POST('requerimento/PostRequerimento', json_submit)
                .then(result => set_requerimento(result.data))
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        } else {
            api_GET('requerimento/' + location.state.requerimento.requerimento_Id)
                .then(result => set_requerimento(result.data))
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
    }

    useEffect(() => {
        loadSteps();
        loadRequerimento();
    }, []);

    // Material-Table > Actions
    const [actions, set_actions] = useState([
        {
            icon: 'edit',
            tooltip: 'Editar Registro',
            disabled: location.state.edit,
            onClick: (event, rowData) => {
                toggle(rowData);
            }
        }
    ]);

    const handleAumentoCapacidade = (event) => {
        set_capacidadeAtualizada(event.target.value);
    }

    const handleFinalizarAumento = () => {

        if (capacidadeAtualizada === "") {
            showMessage("Aviso", "Por favor preencha o campo!", 'error', null);
            return;
        }

        if (capacidadeAtualizada <= localDestinoAtual.capacidadeAntiga) {
            showMessage("Aviso", "A Capacidade alterada tem que ser maior!", 'error', null);
            return;
        }

        const json_submit = {
            requerimento_Id: requerimento.requerimento_Id,
            identificacao: localDestinoAtual.identificacao,
            cep: localDestinoAtual.cep,
            logradouro: localDestinoAtual.logradouro,
            numEndereco: localDestinoAtual.numEndereco,
            complemento: localDestinoAtual.complemento,
            bairro: localDestinoAtual.bairro,
            cidade: localDestinoAtual.cidade,
            uf: localDestinoAtual.uf,
            geoLocalizacao: localDestinoAtual.geoLocalizacao,
            capacidadeAntiga: localDestinoAtual.capacidadeAntiga,
            capacidadeNova: capacidadeAtualizada
        }

        setLoading(true);
        api_POST('RequerimentoDestino/PostRequerimentoDestinoAumentoCapacidade', json_submit)
            .then(result => {
                if (steps.length == 1) {
                    handleFinalizarRequerimento();
                } else {
                    set_step(step + 1);
                }
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleFinalizarRequerimento = () => {
        setLoading(true);
        api_POST('requerimento/PostFinalizarSolicitacaoRequerimento', requerimento)
            .then(result => { showMessage("Aviso", "Solicitação enviada com sucesso. Acompanhe o andamento através do seu cadastro!", 'success', function () { history.push("/auth/meucadastro") }) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    return (
        <>
            {requerimento != null && (requerimento.status == "Em Andamento" || requerimento.status == "Divergente") &&
                <div className="content">
                    <Container className="text-center">
                        <ProgressBar stepValue={step} steps={steps} />
                    </Container>
                    {requerimento.status == "Divergente" && requerimento.requerimentoAnaliseGestor.length > 0 &&
                        <Card className="card-stats">
                            <CardBody>
                                <h5 className={`${session && session.tipoAcesso == "AreaRestrita" ? "text-white" : "text-black"}`}>Seu requerimento foi rejeitado por {setupSistema?.identificacao}. Verifique as informações abaixo e corrija os dados necessários.</h5>
                                <p>{requerimento.requerimentoAnaliseGestor.sort(function (a, b) { return new Date(b.dataAnalise) - new Date(a.dataAnalise); })[0].observacao}</p>
                            </CardBody>
                        </Card>
                    }

                    {step == 0 && (
                        <>
                            <Modal isOpen={modal} toggle={toggle} style={{ marginTop: "200px" }}>
                                <ModalHeader toggle={toggle}>
                                    Capacidade
                                </ModalHeader>
                                <ModalBody>
                                    <Form>
                                        <Row style={{ marginBottom: '10px' }}>
                                            <Col>
                                                <b><label>Capacidade Antiga</label></b>
                                                <Input type="number" name="capacidadeAtualizada" onChange={handleAumentoCapacidade} value={localDestinoAtual.capacidadeAntiga} disabled />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <b><label>Capacidade Nova</label></b>
                                                <Input type="number" name="capacidadeAtualizada" onChange={handleAumentoCapacidade} value={capacidadeAtualizada} />
                                            </Col>
                                        </Row>
                                    </Form>
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="primary" onClick={handleFinalizarAumento}>
                                        Aumentar Capacidade
                                    </Button>
                                </ModalFooter>
                            </Modal>

                            <Card className="card-stats mt-5 p-2">
                                <Row>
                                    <Col md="12">
                                        <MaterialTable style={{ minHeight: "auto" }}
                                            title=""
                                            columns={[
                                                { title: 'Identificação', field: 'identificacao' },
                                                { title: 'Capacidade', field: 'capacidade' },
                                                { title: 'CEP', field: 'cep' },
                                                { title: 'Logradouro', field: 'logradouro' },
                                                { title: 'Número', field: 'numEndereco' },
                                                { title: 'Bairro', field: 'bairro' },
                                                { title: 'Cidade', field: 'cidade' },
                                                { title: 'Status', render: (rowData) => rowData.status != null ? rowData.status : "Ativo" }
                                            ]}
                                            data={locais}
                                            isLoading={false}
                                            actions={actions}
                                            localization={table_translate}
                                            options={table_style}
                                        />
                                    </Col>
                                </Row>
                            </Card>
                        </>

                    )
                    }

                    {steps.length > 1 && step == 1 && <Documentos item={requerimento} opcao={opcao} handleProximoStep={handleFinalizarRequerimento} handleStepAnterior={handleStepAnterior}></Documentos>}
                </div>
            }


        </>
    )
}